import { type FC } from "react";
import { Outlet } from "react-router-dom";
import { Wrapper } from "./PublicMiddleware.styles";
import type { IPublicMiddleware } from "./PublicMiddleware.types";

const PublicMiddleware: FC<IPublicMiddleware> = () => {
  return (
    <Wrapper data-testid={"publicMiddlewareWESR"}>
      <Outlet />
    </Wrapper>
  );
};

export default PublicMiddleware;
